<ng-container>
    <span class="flex items-center gap-2">
        {{ data.value }}
        <app-badge [label]="'Admin'" [type]="'info'" *ngIf="data.meta.isAdmin"></app-badge>
    </span>
</ng-container>
  